import { PrimaryButton } from "../Buttons";
import QRCode from "react-qr-code";
import { toast } from "react-toastify";
import { UploadForm } from "../Upload";
import { FaCopy, FaArrowLeft, FaInfoCircle } from "react-icons/fa";
import CurrencyDisplay from "../Currency/CurrencyDisplay";

export const PageTwo = ({
  pages,
  setPages,
  selectedToken,
  setAmount,
  formik,
  createPaymentLoading,
  usdAmount,
}) => {
  const copyToClipboard = (value) => {
    navigator.clipboard.writeText(value);
    toast.success("Address copied!", { position: "bottom-center" });
  };

  return (
    <div className="p-6 md:p-8">
      {/* Back Button */}
      <button
        onClick={() => setPages(pages - 1)}
        className="flex items-center gap-2 text-sm font-bold  hover:text-gray-600 transition-colors mb-6"
      >
        <FaArrowLeft /> Edit Amount or Method
      </button>

      {/* Payment Summary */}
      <div className="bg-primary/5 border border-primary/10 rounded-2xl p-6 text-center mb-8">
        <p className="text-xs font-bold text-primary uppercase tracking-wide mb-2">
          Total Payable
        </p>
        <div className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-1">
          <CurrencyDisplay usdAmount={usdAmount} className="inline" />
        </div>
        <div className="flex items-center justify-center gap-2 text-sm text-gray-500 font-medium">
          via {selectedToken.tokenName}
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-8">
        {/* Address Details */}
        <div className="flex flex-col justify-center space-y-4">
          {selectedToken.shortName === "BTC" ||
          selectedToken.shortName === "USDT" ||
          selectedToken.shortName === "ETH" ? (
            <div>
              <label className="text-xs font-bold text-gray-400 uppercase">
                Wallet Address
              </label>
              <div
                onClick={() => copyToClipboard(selectedToken.address)}
                className="mt-1 p-3 bg-gray-50 rounded-xl border border-gray-200 hover:border-primary cursor-pointer group transition-all flex items-center justify-between"
              >
                <p className="text-xs font-mono text-gray-600 break-all pr-2">
                  {selectedToken.address}
                </p>
                <FaCopy className="text-gray-400 group-hover:text-primary shrink-0" />
              </div>
            </div>
          ) : (
            <div className="text-sm text-gray-600">
              For payment information, please reach out to our support team.
            </div>
          )}

          <div>
            <label className="text-xs font-bold text-gray-400 uppercase">
              Network
            </label>
            <p className="text-sm font-bold text-gray-800">
              {selectedToken.network}
            </p>
          </div>

          <div className="bg-yellow-50 p-3 rounded-xl flex gap-3 items-start">
            <FaInfoCircle className="text-yellow-500 mt-0.5 shrink-0" />
            <p className="text-xs text-yellow-700 leading-relaxed">
              Please send <strong>{selectedToken.shortName}</strong> only via
              the <strong>{selectedToken.network}</strong> network. Sending
              funds through any other network may result in permanent loss.
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-100 my-8"></div>

      {/* Confirmation Form */}
      <div>
        <h3 className="text-lg font-heading font-bold text-gray-900 mb-6">
          Proof of Payment
        </h3>

        <div className="space-y-6">
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase tracking-wide mb-2">
              Transaction Hash / ID
            </label>
            <input
              type="text"
              {...formik.getFieldProps("transactionRef")}
              placeholder="Paste transaction ID here..."
              className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-primary focus:ring-4 focus:ring-primary/10 transition-all outline-none text-sm"
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase tracking-wide mb-2">
              Upload Screenshot
            </label>
            <div className="border-2 border-dashed border-gray-200 hover:border-primary/50 rounded-2xl p-6 transition-colors bg-gray-50/50">
              <UploadForm formik={formik} />
            </div>
          </div>

          <PrimaryButton
            action={formik.handleSubmit}
            text={
              createPaymentLoading ? "Verifying Transaction..." : "I Have Paid"
            }
            loading={createPaymentLoading}
            className="w-full py-4 text-lg mt-4"
          />
        </div>
      </div>
    </div>
  );
};
